import { useForm } from "react-hook-form";

const UserForm = ({ user, onSave }) => {
  const { register, handleSubmit } = useForm({defaultValues: user})
  const isEdit = !!user;

  return (
    <form onSubmit={handleSubmit(onSave)}>
      <div class="form-group">
        <label for="">Name*</label>
        <input type="text" class="form-control" name="name" ref={register} />
      </div>
      <div class="form-group">
        <label for="">Company name</label>
        <input type="text" class="form-control" name="companyName" ref={register} />
      </div>
      <div class="form-group">
        <label for="" class="">Email*</label>
        <input type="email" class="form-control" name="email" disabled={isEdit} ref={register} />
      </div>
      <div class="form-group pb-3">
        <label for="">Website URL</label>
        <input type="text" class="form-control" name="website" ref={register} />
      </div>
      <div class="form-group">
        <input class="btn btn-primary float-right" type="submit" value="Update account" />
      </div>
    </form>
  )
}

export default UserForm;
